import { Pipe, PipeTransform } from '@angular/core';
import _padStart from 'lodash/padStart';

@Pipe({
  name: 'cpfCnpj',
})
export class CpfCnpjPipe implements PipeTransform {

  readonly MASCARA_CPF = '999.999.999-99';
  readonly MASCARA_CNPJ = '99.999.999/9999-99';

  transform(value: any, args?: any): any {
    if (value) {
      value = value.toString().split('.').join('');
      value = value.toString().replace(/-/,'');
      //console.log(value);
      const selectedMask = value.length > 11 ? this.MASCARA_CNPJ : this.MASCARA_CPF;
      //console.log(selectedMask);
      return this.applyMask(selectedMask, value);
    }
    return null;
  }

  applyMask(mask: string, value: string) {
    let i = 0;
    let maskedValue = '';

    // limpa chars q não sejam números
    if (value) {
      value = value.replace(/\D+/g, '');
    }

    // força o tamanho da máscara
    const size = mask.replace(/\D+/g, '').length;
    value = _padStart(value, size, '0');

    for (let index = 0; index < mask.length; index++) {
      if (i >= value.length) {
        break;
      }

      if (!isNaN(parseFloat(mask[index]))) {
        maskedValue = maskedValue + value[i++];
      } else {
        maskedValue = maskedValue + mask[index];
      }
    }
    return maskedValue;
  }
}
